

// Help Desk URLS - Should be moved to admin settings later, but good enough for now
export const HELP_DESK_URL = 'https://help.vipexperienc.com';
export const TERMS_URL = HELP_DESK_URL + "/hc/en-us/articles/32783150945172-Terms-of-Service-Agreeement";
export const PRIVACY_POLICY_URL = HELP_DESK_URL + "/hc/en-us/articles/360056634712-Privacy-Policy";
export const MODEL_AGREEMENT_URL = HELP_DESK_URL + "/hc/en-us/articles/32782924581908-Model-Agreement";


// Application Page URLs
export const CORE_VIP = 'vip';
export const LOGIN_PAGE_URL = '/login';
export const HOME_PAGE_URL = '/';
export const HOME_PAGE_URL_ALIASES = ['/home', '/vip/home'];
export const MESSAGE_PAGE_URL = '/'+CORE_VIP+'/messages';
export const NEW_MESSAGE_PAGE_URL = '/'+CORE_VIP+'/messages/new';
export const SEARCH_PAGE_URL = '/'+CORE_VIP+'/search';
export const NOTIFICATIONS_PAGE_URL = '/'+CORE_VIP+'/notifications';
export const CIRCLES_PAGE_URL = '/'+CORE_VIP+'/circles';
export const LISTS_PAGE_URL = CIRCLES_PAGE_URL; // Backward compatibility alias
export const SETTINGS_PAGE_URL = '/'+CORE_VIP+'/settings';
export const DASHBOARD_PAGE_URL = '/'+CORE_VIP+'/dashboard';
export const PURCHASES_PAGE_URL = '/'+CORE_VIP+'/purchases';
export const SUBSCRIPTIONS_PAGE_URL = '/'+CORE_VIP+'/subscriptions';
export const FEED_PAGE_URL = '/'+CORE_VIP+'/feed';
export const SCHEDULED_PAGE_URL = '/'+CORE_VIP+'/scheduled';
export const MEDIA_LIBRARY_PAGE_URL = '/'+CORE_VIP+'/library';
export const CATEGORIES_PAGE_URL = '/'+CORE_VIP+'/categories';

export const PAYMENT_SUCCESS_URL = '/payment/success';
export const PAYMENT_DECLINED_URL = '/payment/declined';

export const SINGLE_POST_PAGE_URL = '/post';

// Public user profile pages. Routes.js exposes the clean /:username route
// (Twitter/Instagram style), so profile links are just `/{username}`.
export const getUserProfilePageUrl = (username) =>
    username ? `/${encodeURIComponent(username)}` : '/';

export const VERIFY_EMAIL_URL = '/verify-email';

export const PASSWORD_RESET_URL = '/reset-password';

export const SETTINGS_TABS = {
    PROFILE: 'profile',
    CONTENT: 'content',
    MONETIIZATION: 'monetization',
    TAX: 'tax',
    PRIVACY: 'privacy',
    PAYOUT: 'payout',
    NOTIFICATIONS: 'notifications',
    MESSAGING: 'messaging'

}

// System circle tab identifiers - must match backend CircleType enum values
// (com.vipexperienc.theexperience.model.UserCircle.CircleType)
export const SYSTEM_CIRCLE_TYPES = {
    ALL_SUBSCRIBERS: 'ALL_SUBSCRIBERS',
    FOLLOWERS: 'FOLLOWERS',
    ONLINE_SUBSCRIBERS: 'ONLINE_SUBSCRIBERS',
    REBILL_ON: 'REBILL_ON',
    REBILL_OFF: 'REBILL_OFF',
    COLLABORATORS: 'COLLABORATORS',
    BLOCKED: 'BLOCKED',
    MUTED: 'MUTED',
    RESTRICTED: 'RESTRICTED',
};
